<script setup lang="ts">
import type BuyersConciergeInputVariant from '@consumer/enums/BuyersConciergeInputVariant'
import ConciergeInput from './ConciergeInput.vue'
import ConciergeMadlibs from './ConciergeMadlibs.vue'
import ConciergeTaps from './ConciergeTaps.vue'

export type ConciergeInputVariantName = BuyersConciergeInputVariant

withDefaults(defineProps<{
  variant: ConciergeInputVariantName
  referenceDate?: Date
}>(), {  })
</script>

<template>
  <ConciergeMadlibs v-if="variant === 'madlibs'"/>
  <ConciergeTaps v-else-if="variant === 'taps'" framed :referenceDate="referenceDate"/>
  <ConciergeInput v-else/>
</template>
